/* eslint-disable react/self-closing-comp */
import { createContext, useContext } from "react";
import TemplatesStore from "./TemplatesStore";
import HistoryStore from "./HistoryStore";
import TemplatesDetailStore from "./TemplatesDetailStore";
import ModerationStore from "./ModerationStore";
import AIReviewStore from "./AIReviewStore";
import KeywordsStore from "./KeywordsStore";

export interface IContext {
  TemplatesStore: TemplatesStore;
  HistoryStore: HistoryStore;
  TemplatesDetailStore: TemplatesDetailStore;
  ModerationStore: ModerationStore;
  AIReviewStore: AIReviewStore;
  KeywordsStore: KeywordsStore;
}

export const store: IContext = {
  TemplatesStore: new TemplatesStore(),
  HistoryStore: new HistoryStore(),
  TemplatesDetailStore: new TemplatesDetailStore(),
  ModerationStore: new ModerationStore(),
  AIReviewStore: new AIReviewStore(),
  KeywordsStore: new KeywordsStore(),
};

export const StoreContext = createContext(store);
export const useStore = () => useContext(StoreContext);
